export default "__VITE_ASSET__BCstNiBI__"